import { useEffect } from "react";

export function useScrollToFirstError(submitCount: number) {
  useEffect(() => {
    if (submitCount === 0) return;

    // Defer one tick so accordion expand state updates (triggered by the same
    // submit) have time to commit and MUI can remove MuiCollapse-hidden before
    // we query the DOM.
    // 400ms > MUI Collapse transition-duration (388ms).
    // scrollIntoView called during the height animation calculates the wrong
    // scroll position because the element's layout height is still near zero.
    const id = setTimeout(() => {
      const all = document.querySelectorAll<HTMLElement>(".Mui-error");
      const el = Array.from(all).find(e => !e.closest(".MuiCollapse-hidden"));
      if (!el) return;

      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.querySelector<HTMLElement>("input, select, textarea")?.focus({ preventScroll: true });
    }, 400);

    return () => clearTimeout(id);
  }, [submitCount]);
}
